<template lang="">
  <div>
    <b-card class="mb-4">
      <b-card-title>Sales Tipps</b-card-title>
      <b-card-text>
        <template v-if="hasHints">
          <div
            v-for="hint in hintsArray"
            :key="hint.id"
          >
            <p>
              <router-link :to="hint.link">
                {{ hint.text }}
              </router-link>
            </p>
          </div>
        </template>
        <div v-else>
          Super, alles bestens :)
        </div>
      </b-card-text>
    </b-card>
  </div>
</template>
<script>
import { BCard, BCardText, BLink, BCardTitle, BCardBody } from 'bootstrap-vue'
import businessMetrics from '@/helper/businessMetrics'

export default {
  setup() {
    const {
      getCountOfAllInquiries,
      getAcceptedInquiries,
      getOpenInquiries,
      getActiveOffers,
    } = businessMetrics()

    return {
      getCountOfAllInquiries,
      getAcceptedInquiries,
      getOpenInquiries,
      getActiveOffers,
    }
  },

  components: {
    BCard,
    BCardText,
    BLink,
    BCardTitle,
    BCardBody,
  },

  computed: {
    hintsArray() {
      const hints = []

      if (this.getAcceptedInquiries() !== 0) {
        hints.push({
          id: 'inquiries',
          text: `Es gibt ${this.getAcceptedInquiries()} unqualifizierte Anfrage(n).`,
          link: '/inquiries-list'
        })
      }

      if (this.getActiveOffers() !== 0) {
        hints.push({
          id: 'offers',
          text: `Es gibt ${this.getActiveOffers()} aktive(s) Angebote.`,
          link: '/offers-list'
        })
      }

      return hints
    },

    hasHints() {
      return this.hintsArray.length > 0
    }
  },
}
</script>
<style lang=""></style>
